var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-pill",on:{"click":function($event){return _vm.$emit('remove-filter')}}},[_c('span',[_vm._v(_vm._s(_vm.pillName))]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"remove-filter"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }